import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import { APP_SETTINGS } from "./hooks/useAppSettings";
import { UserProvider } from './contexts/UserContext';
// Make sure to call `loadStripe` outside of a component’s render to avoid
const stripePromise = loadStripe(APP_SETTINGS.stripeKey);

const appearance = {
  theme: 'stripe',

  variables: {
    colorPrimaryText: '#ffffff',
    colorTextPlaceholder: '#ffffff',
    colorBackground: '#ffffff',
    colorText: 'white',
    colorDanger: '#df1b41',
    fontFamily: 'Ideal Sans, system-ui, sans-serif',
    spacingUnit: '2px',
    borderRadius: '4px',
    // See all possible variables below
  }
};


const options = {
  mode:'payment',
  amount: APP_SETTINGS.monthlySubscription,
  currency: APP_SETTINGS.currency,
  // Fully customizable with appearance API.
  appearance:appearance
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <UserProvider>
    <Elements stripe={stripePromise} options={options}>
      
      <App />
    </Elements>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
